export default "__VITE_ASSET__db4a6788__"